import React from 'react';


const Footer = () =>
	<div className="Footer">
		<div>&copy; GAMEDEV_COMMAND, 2022.</div>
	</div>

export default Footer